// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/ypx7idz.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body[data-v-bf404516],html[data-v-bf404516]{font-size:14px}#app[data-v-bf404516]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;font-family:poppins,sans-serif;font-weight:400;font-style:normal}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
